import { memo } from "react";
import Modal from "ui/atoms/Modal";
import { useShipmentTrackingContext } from "./ShipmentTrackingProvider";
import ShipmentTrackingView from "./ShipmentTrackingView";

const ShipmentTrackingDetail = () => {
    const { open, resource, onClose } = useShipmentTrackingContext();

    return (
        <Modal
            isOpen={open}
            disableCloseOnBackdropClick
            titleSlot='Shipment tracking details'
            onClose={onClose}
            DialogProps={{
                sx: {
                    '& .MuiPaper-root': {
                        maxWidth: 750
                    }
                }
            }}
        >
            {resource && (
                <ShipmentTrackingView resource={resource} />
            )}
        </Modal>
    );
};

export default memo(ShipmentTrackingDetail);
